import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=56d46b1f&scoped=true"
import script from "./Chip.vue?vue&type=script&lang=ts"
export * from "./Chip.vue?vue&type=script&lang=ts"
import style0 from "./Chip.vue?vue&type=style&index=0&id=56d46b1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d46b1f",
  null
  
)

export default component.exports